const ProgressBar3 = () => {
	return (
		<svg
			width='150'
			height='4'
			viewBox='0 0 150 4'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<rect width='150' height='4' rx='2' fill='#E7E7E7' />
			<path
				d='M0 2C0 0.895431 0.895431 0 2 0H148C149.105 0 150 0.895431 150 2V2C150 3.10457 149.105 4 148 4H2C0.895429 4 0 3.10457 0 2V2Z'
				fill='#7E50FF'
			/>
		</svg>
	);
};

export default ProgressBar3;
